import { ValueProperty } from '../../../interfaces';
import { getFromCallable } from '../../../../../../utils';

export function getValue<Dto extends Record<keyof Dto, any> = any>(
    value: ValueProperty<Dto[keyof Dto]>,
): Dto[keyof Dto] {
    return getFromCallable(value);
}
